import { call, put, select } from 'redux-saga/effects';

import API from 'services/api';

import { getGroupId } from 'store/session/selectors';

import { fetchQuickbooksInfo } from './actions';

function* watchFetchQuickbooksInfo() {
  try {
    const groupId = yield select(getGroupId);
    const { connected, error, url } = yield call(
      API.integrations.getQuickbooksInfo,
      groupId,
    );
    yield put(fetchQuickbooksInfo.success({ connected, error, url }));
  } catch (error) {
    yield put(fetchQuickbooksInfo.error(error));
  }
}

export function* initSaga() {
  yield call(watchFetchQuickbooksInfo);
}
